<template>
    <div :class="pageCls">
        <div class="g-main">
            <a href="javascript:;" class="app-top-link openApp" v-if="showAppTopLink && !$route.query.isGovPreviewPage">
            </a>
            <slot></slot>
            <a href="javascript:;" class="app-bot-link openApp" id="openApp" v-if="showAppBotLink">
                {{ appBotLinkText }}
            </a>
        </div>
        <!--<div
			:class="['app-down-guid', show_guid ? 'slide-in' : '', isIos ? 'ios' : 'adr']"
			:style="{width: appW + 'px'}"
			@click="toggleGuid">
		</div>-->
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { app_down_link, app_open_link, app_bot_link_text } from 'constants/project'
import { isIos, isWx } from 'constants/device'
// import { wxShare } from 'services/wxShare'
import wxShare from 'services/weChatShare'
var isMlinked = false;
export default {
    props: {
        type: String,
        showAppTopLink: {
            type: Boolean,
            default: true
        },
        showAppBotLink: {
            type: Boolean,
            default: true
        },
        hasComments: {
            type: Boolean,
            default: false
        },
        detail: {
            type: Object,
            default () {
                return {};
            }
        },
        autoOpenApp: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapGetters({
            appW: 'app:width'
        }),
        pageCls () {
            let cls = ['p-common'];
            if (!Jt.string.isEmpty(this.type)) {
                cls.push('p-' + this.type);
            }
            return cls;
        },
        appBotLinkText () {
            if (this.hasComments) {
                return app_bot_link_text['hasComments'];
            }
            return app_bot_link_text['noComments'];
        },
        isIos () {
            if (isIos) {
                return true;
            }
            return false;
        }
    },
    watch: {
        detail (newVal, oldVal) {
            if (!Jt.object.isEmpty(newVal)) {
                this.setShareData(newVal);
                let data = newVal;
                if (!isMlinked && this.showAppTopLink) {
                    try {
                        new JMLink([{
                            jmlink: 'https://bciq41.jglinks.cn/Aan7',//短链地址
                            button: document.querySelectorAll('a.openApp'),
                            autoLaunchApp: false,
                            autoRedirectToDownloadUrl: true,
                            downloadWhenUniversalLinkFailed: false,
                            inapp: false,
                            params: {
                                articleId: data.id,
                                categoryId: data.categoryId,
                                sysCode: data.sysCode || "",
                                type: data.type || "",
                                link: data.link || ""
                            }
                        },
                            // {
                            //     mlink:'https://av5dak.mlinks.cc/AcvA',//短链地址
                            //     button:document.querySelector('a#openApp'),
                            //     autoLaunchApp : false,
                            //     autoRedirectToDownloadUrl: true,
                            //     downloadWhenUniversalLinkFailed: false,
                            //     inapp : false,
                            //     params: {
                            //         articleId:data.id,
                            //         categoryId:data.categoryId,
                            //         sysCode:data.sysCode||"",
                            //         type:data.type||"",
                            //         link:data.link|| ""
                            //     }
                            // }
                        ]);
                    } catch (error) {
                        console.log('mlink:', error)
                    }
                    isMlinked = true;
                }
                // if(this.autoOpenApp) {
                // 	this.openApp();
                // }
            }
        }
    },
    data () {
        return {
            'show_guid': false
        };
    },
    methods: {
        // downApp() {
        // 	if(isWx) {
        // 		this.toggleGuid();
        // 		return false;
        // 	}
        // 	this.openApp();
        // 	setTimeout(function() {
        // 		window.location.href = app_down_link;
        // 	}, 500);
        // },
        // openApp() {
        // 	if(isWx && Jt.object.isEmpty(this.detail)) {
        // 		return;
        // 	}
        // 	let openLink = this.getOpenLink();
        // 	let iframe = document.createElement('iframe');
        // 	iframe.style.display = 'none';
        // 	iframe.src = openLink;
        // 	let cb = function() {
        // 		if(iframe == null) { return; }
        //            iframe.onload = iframe.onerror = iframe.onreadystatechange = null;
        //            iframe.src = "";
        //            iframe.parentNode.removeChild(iframe);
        //            iframe = null;
        // 	};
        // 	iframe.onload = iframe.onerror = iframe.onreadystatechange = cb;
        //       	document.getElementsByTagName("body")[0].appendChild(iframe);
        //        setTimeout(function() {
        //            cb();
        //        },100);
        // },
        // getOpenLink() {
        // 	let str = '';
        // 	if(this.autoOpenApp) {
        // 		let data = this.detail;

        // 		let params = {
        // 			articleId:data.id,
        // 			categoryId:data.categoryId,
        // 			sysCode:data.sysCode||"",
        // 			type:data.type||"",
        // 			link:data.link|| ""
        // 		};
        // 		for(let i in params) {
        // 			str += '&' + i + '=' + encodeURIComponent(params[i]);
        // 		}
        // 		str = str.substr(1);
        // 	}
        // 	return app_open_link + str;
        // },
        toggleGuid () {
            this.show_guid = !this.show_guid;
            this.$nextTick(function () {
                if (this.show_guid) {
                    Jt.browser.stopBodyScroll();
                }
                else {
                    Jt.browser.startBodyScroll();
                }
            });
        },
        setShareData (data) {
            // if (this.showAppTopLink) {
            //           wxShare({
            //               title: data.title
            //           },this)
            // }

            $("head").append('<meta name="description" itemprop="description" content="天下景观在锦观" />');
            $("head").append('<meta itemprop="image" content="http://rmrbpre.img-cn-beijing.aliyuncs.com/cdrb2/dir2/20190513/cdrb_2_201503133341dc-40bd-4efb-85f2-ae81b3c86ccc.png" />')

            if (data.title) {
                document.title = data.title
                $(document).attr("title", data.title);
                $("head").append('<meta itemprop="name" content=' + data.title + ' />');
            }
        }
    }
}

</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import "~src/stylus/mixin";
	@import "~src/styles/base.styl";
	@import '~src/styles/page-common.styl';
</style>


// WEBPACK FOOTER //
// page-common.vue?a88d433e